// import matchSorter from 'match-sorter';
// import memProfile from 'memoizee/profile';
// import memoizee from 'memoizee';
import filter from 'lodash/filter';
import transform from 'lodash/transform';
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
import get from 'lodash/get';
import forOwn from 'lodash/forOwn';
import { normalize, schema } from 'normalizr';

import * as c from './constants';
import * as api from './api';
import { fetchCollectionData, fetchDigitalAsset, fetchItem, getAssetURL, getRelatedAssetURL } from './api';
import { FaExternalLinkAlt, FaFileAlt, FaFileArchive, FaFileCsv, FaFileExcel, FaFilePdf, FaFileWord } from 'react-icons/fa';

// function matchAndSortFn(items, value, keys = ['label']) {
//     return value
//         ? matchSorter(items, value, {
//               keys,
//               threshold: matchSorter.rankings.CONTAINS
//           })
//         : items;
// }

// export const matchAndSort = memoizee(matchAndSortFn, { max: 10 });

const assetClasses = new schema.Entity(
    'asset_classes',
    {},
    {
        idAttribute: 'code',
    }
);

const asset = new schema.Entity(
    'asset',
    {
        asset_classes: [assetClasses],
    },
    {
        idAttribute: 'filename',
    }
);

const assetsCollection = new schema.Array(asset);

/**
 * MOCK DATA GIACENZE - TODO: rimuovere dopo il test
 *
 * Genera dati mock per testare la visualizzazione delle giacenze
 */
function getMockGiacenzeData() {
    const mockRows = [
        { giacenza: 10.5, data_giacenza: "2025-10-06" },
        { giacenza: 25.0, data_giacenza: "2025-10-05" },
        { giacenza: 8.0, data_giacenza: "2025-10-04" },
        { giacenza: 42.5, data_giacenza: "2025-10-03" },
    ]

    return {
        property: "giacenze",
        label: { "it_IT": "Giacenze" },
        value: null,
        children: mockRows.map((row) => ([
            {
                property: "giacenza",
                label: { "it_IT": "Quantità" },
                value: row.giacenza,
                children: []
            },
            {
                property: "data_giacenza",
                label: { "it_IT": "Data Giacenza" },
                value: row.data_giacenza,
                children: []
            }
        ]))
    }
}

/**
 *
 * @param collection
 * @param key
 * @returns {*}
 */
function filterAssetsCollection(collection, key) {
    return collection.map((a) => {
        a.asset_classes = filter(a.asset_classes, { asset_type: key });

        return a;
    });
}

// export function normalizeArticleDetails(data) {
//     return {
//         ...data,
//         assets: transform(
//             data.assets,
//             (assets, v, k) => {
//                 assets[k] = normalizeAssetsCollection(v, k);

//                 return assets;
//             },
//             {}
//         )
//     };
// }

/**
 *
 * @param collection
 * @param key
 * @returns {NormalizedSchema<{[p: string]: {[p: string]: any} | undefined}, any>}
 */
export const normalizeAssetsCollection = (collection, key) => {
    const filteredCollection = filterAssetsCollection(collection, key);

    return normalize(filteredCollection, assetsCollection);
};

export const removeSplashScreenLoader = () => {
    const loaderNode = document.getElementById('app-loader');

    if (loaderNode) {
        loaderNode.remove();
    }
};

const categories = Object.values(c.ARTICLE_DETAIL_SECTIONS);

/**
 * Usato per determinare se una categoria deve essere visibile o meno nella modale dell' articolo
 * @param details
 * @returns {{}}
 */
export function getCategoryButtonStatus(details) {
    const base = categories.reduce((obj, category) => {
        obj[category.key] = true;

        return obj;
    }, {});

    // Verifica se una sezione repeatable ha almeno un valore non nullo
    const hasRepeatableContent = (entries) => {
        if (!entries || !isArray(entries) || entries.length === 0) return false;
        return entries.some(entry =>
            Object.values(entry).some(prop => prop && prop.value !== null && prop.value !== undefined)
        );
    };

    // console.log('base => ', base)
    // console.log('details => ', details)

    if (!isArray(details.articoli_correlati) || details.articoli_correlati.length === 0) {
        base[c.SECTION_KEY_CORRELATI] = false;
    }

    if (!hasRepeatableContent(details.confezionamenti)) {
        base[c.SECTION_KEY_PACKAGING] = false;
    }

    if (!hasRepeatableContent(details.prezzi)) {
        base[c.SECTION_KEY_PRICING] = false;
    }

    if (!details.listini || Object.keys(details.listini).length === 0) {
        base[c.SECTION_KEY_LISTINI] = false;
    }

    if (!details.assets || !details.assets.altro || details.assets.altro.length === 0) {
        base[c.SECTION_KEY_ALTRO] = false;
    }

    if (!details.assets || !details.assets.disegno || details.assets.disegno.length === 0) {
        base[c.SECTION_KEY_DISEGNI] = false;
    }

    if (!details.assets || !details.assets.documento || details.assets.documento.length === 0) {
        base[c.SECTION_KEY_DOCUMENTI] = false;
    }

    if (!details.assets || !details.assets.immagine || details.assets.immagine.length === 0) {
        base[c.SECTION_KEY_IMMAGINI] = false;
    }

    if (!details.assets || !details.assets.vettoriale || details.assets.vettoriale.length === 0) {
        base[c.SECTION_KEY_VETTORIALI] = false;
    }

    if (!details.assets || !details.assets.videoclip || details.assets.videoclip.length === 0) {
        base[c.SECTION_KEY_VIDEO] = false;
    }

    if(!details.article_digital_asset || details.article_digital_asset?.length === 0) base[c.SECTION_KEY_DIGITAL_ARTICLE_ASSET] = false
    if(!details.line_digital_asset || details.line_digital_asset?.length === 0) base[c.SECTION_KEY_DIGITAL_LINE_ASSET] = false
    if(!details.serie_digital_asset || details.serie_digital_asset?.length === 0) base[c.SECTION_KEY_DIGITAL_SERIE_ASSET] = false
    if(!details.model_digital_asset || details.model_digital_asset?.length === 0) base[c.SECTION_KEY_DIGITAL_MODEL_ASSET] = false
    if(!details.brand_digital_asset || details.brand_digital_asset?.length === 0) base[c.SECTION_KEY_DIGITAL_BRAND_ASSET] = false
    if(!details.domuspartes_digital_asset || details.domuspartes_digital_asset?.length === 0) base[c.SECTION_KEY_DIGITAL_DOMUSPARTES_ASSET] = false

    if (!details.etim || !details.etim.etim_features || details.etim.id === null) {
        base[c.SECTION_KEY_CARATTERISTICHE] = false;
    }

    if (!details.identificazione) {
        base[c.SECTION_KEY_ID] = false;
    }

    if (!details.dettagli_ordine  || isEmptyObject(details.dettagli_ordine)) {
        base[c.SECTION_KEY_ORDINE] = false;
    }

    if (!details.aggregazioni) {
        base[c.SECTION_KEY_AGGREGAZIONI] = false;
    } else {
        const notNullAggregazioni = transform(
            details.aggregazioni,
            (result, item) => {
                if (item.value !== null) {
                    result.tot += 1;
                } else if (item.children && item.children.length > 0 && item.children.some(c => c.value !== null)) {
                    result.tot += 1;
                }
            },
            { tot: 0 }
        );

        if (notNullAggregazioni.tot === 0) {
            base[c.SECTION_KEY_AGGREGAZIONI] = false;
        }
    }
    if(!details.pinaxo) {
        base[c.SECTION_KEY_PINAXO] = false
    }

    if (!details.varie) {
        base[c.SECTION_KEY_VARIE] = false;
    } else {
        const notNullVarie = transform(
            details.varie,
            (result, item) => {
                if (item.value !== null) {
                    result.tot += 1;
                }
            },
            { tot: 0 }
        );

        if (notNullVarie.tot === 0) {
            base[c.SECTION_KEY_VARIE] = false;
        }
    }

    // console.warn(details.misure);

    if (!details.misure) {
        base[c.SECTION_KEY_MISURE] = false;
    } else {
        const misure = transform(
            details.misure,
            (result, obj) => {
                if (obj.value !== null) {
                    result.push(obj.value);
                }

                return result;
            },
            []
        );

        if (misure.length === 0) {
            base[c.SECTION_KEY_MISURE] = false;
        }
    }

    const categoryKeys = categories.map((c) => c.key);

    forOwn(details, (v, k) => {
        if (!includes(categoryKeys, k) && !includes(c.EXTRA_CATEGORIES_BLACKLIST_KEYS, k)) {
            if (Object.keys(v).length > 0) {
                const values = transform(
                    v,
                    (result, obj) => {
                        // console.warn(obj);
                        if (obj.value !== null || obj.children.length > 0) {
                            result.push(obj.value);
                        }

                        return result;
                    },
                    []
                );

                if (values.length === 0) {
                    base[k] = false;
                } else {
                    base[k] = true;
                }
            }
        }
    });

    return base;
}


/**
 *
 * @param data
 * @returns {{id: *, metadata, integrations}}
 */
export function normalizeArticleDetails(data) {
    const repeatables = ['prezzi', 'confezionamenti', 'listini'];

    let details = {
        id: data.id,
        metadata: data.metadata || {},
        integrations: data.integrations || {},
    };

    data.children.forEach((category) => {
        details[category.property] = category.children.reduce((obj, property) => {
            if (includes(repeatables, category.property)) {
                if (!isArray(obj)) {
                    obj = [];
                }

                obj.push(
                    property.children.reduce((propObj, p) => {
                        propObj[p.property] = p;

                        return propObj;
                    }, {})
                );
            } else if (category.property === 'assets') {
                const type = get(property, 'value.asset_classes[0].asset_type', 'altro');

                if (!obj[type]) {
                    obj[type] = [];
                }

                obj[type].push(property.value);
            } else if (category.property === 'etim') {
                if (property.property === 'etim_class') {
                    if (property.value) {
                        obj.id = property.value.id;
                        obj.name = property.value.name;
                        obj.label = property.value.label;
                    } else {
                        // FIXME: tradurre
                        obj.id = null;
                        obj.name = 'Non categorizzato';
                        obj.label = 'Non categorizzato';
                    }
                } else if (property.property === 'etim_features') {
                    obj.etim_features = property.children.reduce((featObj, f) => {
                        featObj[f.value.id] = f.value;

                        return featObj;
                    }, {});
                }
            } else if (category.property === c.SECTION_KEY_CORRELATI) {
                if (!isArray(obj)) {
                    obj = [];
                }

                obj.push(property.value);
            } else {
                if(category.property === 'identificazione' && property.property === 'descrizione_articolo') {

                    if(!property.value) {
                        obj[property.property] = []
                    }else{
                        property.value = Object.fromEntries(
                            Object.entries(property.value).map(([lang, descrizione]) => {
                                return [lang, truncateText(descrizione, 250)]
                            })
                        )
                    }

                }
                obj[property.property] = property;
            }

            return obj;
        }, {});
    });

    repeatables.forEach((key) => {
        if (!isArray(details[key])) {
            details[key] = [];
        }
    });

    // console.warn('details from normalize => ', details)

    return details
}

/**
 * Merge dei details degli assets dell' articolo (immagine, disegno, vettoriale, documento, altro)
 * in un unico object in cui
 * @param article
 * @returns {*}
 */
export const mergeArticleAssets = (article) => {
    const { assets, ...rest } = article ?? {};

    const article_digital_asset = Object.entries(assets ?? {}).flatMap(
        ([assetType, items]) =>
            Array.isArray(items)
                ? items.map((item) => {
                    const asset_classes_type = (item.asset_classes ?? [])
                        .map((cls) => cls?.code)
                        .filter(Boolean);

                    return {
                        ...item,
                        asset_type: assetType,
                        asset_classes_type,
                    };
                })
                : []
    );

    return { ...rest, article_digital_asset };
};



function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
}
/**
 *
 * @param assets
 * @param key
 * @param locale
 * @returns {*[]}
 */
export function sortArticleAssets(assets, key = 'url', locale = 'it') {
    if (!Array.isArray(assets)) return [];

    return [...assets].sort((a, b) => {
        const valA = getNestedValue(a, key);
        const valB = getNestedValue(b, key);

        const nameA = (valA ?? '').toString().toLowerCase();
        const nameB = (valB ?? '').toString().toLowerCase();

        return nameA.localeCompare(nameB, locale, { sensitivity: 'base' });
    });
}

/**
 *
 * @param id
 * @returns {Promise<{id: *, metadata, integrations}>}
 */
export async function fetchItemDetails(id) {
    // Recupero prima i dati dell' articolo
    const { data } = await fetchItem(id);

    // Estraggo subito i dati che ci serviranno per gli altri tipi di assets: la siglaMarca (ACC, VGA, etc, i codici della marca)
    const siglaMarca = getSiglaMarcaFromArticle(data.children)

    let lineaDigitalAsset = null
    let seriesDigitalAsset = null
    let modelloDigitalAsset = null
    let brandDigitalAsset = null
    let domusPartesDigitalAsset = null

    if(siglaMarca){
        const linee = getAggregazioneValues(data, 'linee')
        if(Array.isArray(linee) && linee[0].code) lineaDigitalAsset = await getDigitalAssets(siglaMarca, 'linea', linee)

        const series = getAggregazioneValues(data, 'serie')
        if(Array.isArray(series) && series[0].code) seriesDigitalAsset = await getDigitalAssets(siglaMarca, 'serie', series)

        const modelli = getAggregazioneValues(data, 'modello')
        if(Array.isArray(modelli) && modelli[0].code) modelloDigitalAsset = await getDigitalAssets(siglaMarca, 'modello', modelli)

        // Brand non ha altri parametri, passiamo direttamente la sigla marca
        brandDigitalAsset = await getDigitalAssets(siglaMarca, 'brand')

        // DomusPartes non ha altri parametri oltre la siglaMarca
        domusPartesDigitalAsset = await getDigitalAssets(siglaMarca, 'domuspartes')
    }
    
    const articleDetailsNormalized = normalizeArticleDetails(data);

    const merged = mergeArticleAssets(articleDetailsNormalized);
    const sorted = sortArticleAssets(merged.article_digital_asset, 'asset_classes.0.code');

    const  { article_digital_asset, ...rest} = merged

    const processed = {
        ...rest,
        article_digital_asset: sorted,
        line_digital_asset: lineaDigitalAsset,
        serie_digital_asset: seriesDigitalAsset,
        model_digital_asset: modelloDigitalAsset,
        brand_digital_asset: brandDigitalAsset,
        domuspartes_digital_asset: domusPartesDigitalAsset
    }

    // MOCK DATA GIACENZE - TODO: rimuovere dopo il test
    // if (!processed.integrations) {
    //     processed.integrations = {}
    // }
    // processed.integrations.giacenze = getMockGiacenzeData()
    // END MOCK DATA GIACENZE

    // console.log('articleDetailsNormalized', articleDetailsNormalized)
    // console.log('processed', processed)
    return processed
    //return details
}

/**
 *
 * @param siglaMarca
 * @param type il tipo di asset
 * @param elements i valori dell' assets, come ad esempio i nomi delle linee o serie, i nomi dei modelli (i loro id/code)
 * @returns {Promise<*[]|null>}
 */
export const getDigitalAssets = async (siglaMarca, type, elements = null) => {
    if(!siglaMarca) return null

    let results = []

    if(!elements || elements.length === 0){
        const { data } = await fetchDigitalAsset(siglaMarca, type)
        results = data
    }

    if(elements){
        for (const element of elements){
            const { data } = await fetchDigitalAsset(siglaMarca,type, element.label)
            results.push(...data)
        }
    }

    if (!results) return null

    let normalizedResult = []
    Object.entries(results).forEach(([key, value]) => {
        const normalizedValue = normalizeRelatedAssetData(value, siglaMarca)

        if(!normalizedValue) return

        normalizedResult[key] = normalizedValue
    })

    return normalizedResult
}

export const getAggregazioneValues = (articleData, aggregazioneName) => {

    if(!articleData) return null

    if(!articleData?.children) return null

    if(!aggregazioneName) return null

    const articleDataChildren = articleData?.children

    let aggregazioneValues = null

    for (const obj of articleDataChildren) {

        if(obj?.property === 'aggregazioni') {
            aggregazioneValues = obj
            break;
        }

    }

    if(!aggregazioneValues) return null

    if(!aggregazioneValues.children) return null

    let singleAggregazioneValues = null
    for (const child of aggregazioneValues.children) {

        if(child?.property === aggregazioneName) {
            singleAggregazioneValues = child
        }
    }

    if(!singleAggregazioneValues) return null

    if(!singleAggregazioneValues.children && !singleAggregazioneValues.value ) return null

    let result = []
    if(singleAggregazioneValues.children.length > 0){
        for (const singleItem of singleAggregazioneValues.children) {
            const itemNormalized = {
                "property": singleItem.property,
                "value": singleItem.value,
                "code": singleItem?.value?.code,
                "label": singleItem?.value?.label?.it_IT,
            }
            result.push(itemNormalized)
        }
    }else if(singleAggregazioneValues?.value?.code !== ''){
        const singleItem = singleAggregazioneValues.value

        const itemNormalized = {
            "property": singleAggregazioneValues.property,
            "value": singleItem?.value?.code,
            "code": singleItem?.value?.code,
            "label": singleItem?.label?.it_IT,
        }
        result.push(itemNormalized)
    }

    return result
}

/**
 *
 * @param data
 * @param siglaMarca
 * @returns {{url: string, description: *, locales: null, metadata: *[], asset_classes: [{code: *, label: {it_IT: *, en_GB: string, fr_FR: string, de_DE: string, es_ES: string, ru_RU: string, ro_RO: string, bg_BG: string, sq_AL: string, el_GR: string}, asset_type: string, alternative_code: *}], public_url: null, extension: string, size: *, asset_type: *, asset_classes_type: *[]}|null}
 */
export const normalizeRelatedAssetData = (data, siglaMarca) => {

    if(!data) return null
    if(!siglaMarca) return null
    // console.log('normalizeRelatedAssetData => ' , data.element_type, data?.filename)

    // Controlla se il filename è un URL esterno
    const isExternalUrl = isUrlAsset(data?.filename)

    let url = null
    let filename = null
    let publicUrl = null
    let extension = null

    if (isExternalUrl) {
        // Se è un URL esterno, lo usiamo direttamente senza preporre la sigla marca
        url = data?.filename
        filename = data?.filename
        publicUrl = data?.filename
        extension = "url"
    } else {
        // Comportamento normale per i file
        const urlWithEncodedSlash = (data.element_type === 'domuspartes' ?
            getRelatedAssetURL(encodeURIComponent(`${siglaMarca}/${data?.filename}`))
            :
            getAssetURL(encodeURIComponent(`${siglaMarca}/${data?.filename}`)))

        url = urlWithEncodedSlash ? urlWithEncodedSlash.replaceAll('%2F', '/') : null
        filename = `${siglaMarca}/${data?.filename}`
        // Calcola l'estensione reale dal filename
        extension = getFileExtension(data?.filename)
    }

    return  {
        "id": data?.id,
        "url": url,
        "filename": filename,
        "description": data?.element_description,
        "locales": null,
        "metadata": [],
        "asset_classes": [
            {
                "code": data?.asset_class_description,
                "label": {
                    "it_IT": data?.asset_class_description,
                    "en_GB": "",
                    "fr_FR": "",
                    "de_DE": "",
                    "es_ES": "",
                    "ru_RU": "",
                    "ro_RO": "",
                    "bg_BG": "",
                    "sq_AL": "",
                    "el_GR": "ν"
                },
                "asset_type": "disegno",
                "alternative_code": data?.asset_class
            }
        ],
        "public_url": publicUrl,
        "extension": extension,
        "size": data?.filesize,
        "asset_type": data?.asset_class_description,
        "asset_classes_type": [
            data?.asset_class_description
        ]
    }
}
/**
 * Recupera il code della marca dai dati dell' articolo
 * @param articleData
 * @returns {*|null}
 */
export const getSiglaMarcaFromArticle = (articleData) => {
    if(!articleData) return null
    if(!Array.isArray(articleData)) return null

    let identificazioneArticleData = null
    Object.entries(articleData).forEach(([key, value]) => {
        if(value.property === 'identificazione') {
            identificazioneArticleData = value
        }
    })

    if(!identificazioneArticleData) return null
    if(identificazioneArticleData.children.length === 0) return null

    let siglaMarca = null
    Object.entries(identificazioneArticleData.children).forEach(([key, value]) => {
        if(value.property === 'sigla_marca'){
            siglaMarca = value?.value?.code
        }
    })

    if(!siglaMarca) return null

    return siglaMarca

}

/**
 * Estrae un array di asset_type unici dagli asset
 * @param assets
 * @returns {any[]|*[]}
 */
export const extractUniqueAssetTypes = (assets) => {
    if (!assets || assets.length === 0) return [];

    const uniqueTypes = [...new Set(assets.map(asset => asset.asset_type))];
    return uniqueTypes.filter(type => type).sort();
};

export const extractUniqueAssetClasses = (assets, locale = 'it_IT') => {
    if (!assets || assets.length === 0) return [];

    // Creo una mappa code -> {code, label} per evitare duplicati
    const classesMap = new Map();

    assets.forEach(asset => {
        asset?.asset_classes?.forEach(assetClass => {
            if (assetClass?.code && !classesMap.has(assetClass.code)) {
                classesMap.set(assetClass.code, {
                    code: assetClass.code,
                    label: assetClass.label?.[locale] || assetClass.label?.it_IT || assetClass.code
                });
            }
        });
    });

    // Converto il locale da it_IT a it-IT per localeCompare
    const jsLocale = locale.replace('_', '-');

    // Converto la mappa in array e ordino per label
    return Array.from(classesMap.values()).sort((a, b) =>
        a.label.localeCompare(b.label, jsLocale, { sensitivity: 'base' })
    );
}

/**
 * Estrae le asset classes uniche filtrate per una specifica description (linea/serie/modello).
 * Se selectedDescription è vuota, ritorna tutte le asset classes.
 * @param assets
 * @param selectedDescription
 * @param locale
 * @returns {*[]}
 */
export const extractUniqueAssetClassesByDescription = (assets, selectedDescription, locale = 'it_IT') => {
    if (!assets || assets.length === 0) return [];

    // Se non c'è una description selezionata, ritorna tutte le asset classes
    if (!selectedDescription) {
        return extractUniqueAssetClasses(assets, locale);
    }

    // Filtra gli assets per la description selezionata
    const filteredAssets = assets.filter(asset => asset.description === selectedDescription);

    // Estrae le asset classes dagli assets filtrati
    return extractUniqueAssetClasses(filteredAssets, locale);
}

/**
 * Estrae un array di description unici dagli assets.
 * Le description contengono il nome della linea, o del modello, o della serie.
 * @param assets
 * @returns {any[]|*[]}
 */
export const extractUniqueAssetDescriptionType = (assets) => {
    if (!assets || assets.length === 0) return [];

    const uniqueDescriptionsType = [...new Set(assets.map(asset => asset.description))]
    return uniqueDescriptionsType.filter(type => type).sort()
}

/**
 *
 * @param article
 * @param locale
 * @returns {unknown}
 */
export function getDescrizioneMarcaFromArticolo(article, locale) {
    return (
        get(article, 'identificazione.descrizione_marca.value') ||
        get(article, `identificazione.sigla_marca.value.label.${locale}`) ||
        get(article, 'identificazione.sigla_marca.value.code')
    );
}

// export const profiler = memProfile;

/**
 * Determina se il payload attuale consente o meno di avere il filtro fuori cartaceo
 * se abbiamo più di una sigla_marca ritorna false
 * @param apiPayload
 * @returns {Promise<boolean>}
 */
export const haveFuoriListinoCartaceoProperty = async (apiPayload) => {
    // Rimuovo se presente la chiave del filtro fuori cartaceo dall' object apiPayload
    const { fuori_listino_cartaceo, ...apiPayloadNoFuoriCartaceo } = apiPayload;
    // Faccio una fecth per vedere se ho valori
    const fuoriListinoCartaceoOptions = await api.fetchFuoriCartaceoFilter(apiPayloadNoFuoriCartaceo)
    // Se non ho valori
    if(!fuoriListinoCartaceoOptions) return false
    // Estraggo le marche dal payload
    const { sigle_marca } = apiPayload
    // Se sono più di 1 ritorno false ( non abilito il filtro fuori cartaceo )
    if(sigle_marca?.size > 1) return false
    // Se più di un valore significa che ci sono dei valori per il filtro fuori cartaceo, lo mostro
    return fuoriListinoCartaceoOptions.data.length > 1
}


/**
 * Faccio la count dei brands di una collection
 * @param collection
 * @returns {Promise<number|number|number>}
 */
export const collectionBrandsCount = async (collection) => {
    const collectionPayload = {
        "collezione": collection,
        "per_page": 100
    }
    const result = await fetchCollectionData(collectionPayload)

    if(!result) return 0
    // Extract all the sigla_marca from children
    const siglaMarche = result?.results?.flatMap(item =>
        item.children
            .filter(child => child.property === "sigla_marca")
            .map(child => child.value.code) // take only the code value
    )

    // Use Set to get the value
    const uniqueSiglaMarche = [...new Set(siglaMarche)]

    // Count how many are
    const countUniqueSiglaMarche = uniqueSiglaMarche.length

    return countUniqueSiglaMarche ? countUniqueSiglaMarche : 0
}


/**
 * Converte una stringa in un valore esadecimale
 * @param inputString
 * @returns {string}
 */
export const stringToHex = (inputString) => {
    if(!inputString) return ''
    return Array.from(inputString, (char) =>
        char.charCodeAt(0).toString(16).padStart(2, '0')
    ).join('');
}
/**
 * Truncate string based on the maxLength passed as parameter
 * @param {string} text - the string will be truncated
 * @param {int} maxLength - tha max number of characters allowed
 */
export const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.slice(0, maxLength) : text
}

/**
 * truncateFileName
 *
 * Truncate filename based on the maxLength passed as parameter
 * @param {string} filename - the string filename will be truncated
 * @param {int} maxLength - tha max number of characters allowed
 */
export const truncateFileName = (filename, maxLength) => {
    const extIndex = filename.lastIndexOf(".")

    if (extIndex === -1) return filename.length > maxLength ? filename.slice(0, maxLength) + "..." : filename

    const name = filename.slice(0, extIndex)
    const ext = filename.slice(extIndex)

    return name.length > maxLength ? name.slice(0, maxLength) + "..." + ext : filename
}

/**
 * Determina se il file passato è un file di tipo documento o archivio
 * @param file
 * @returns {boolean|null}
 */
export const isDocumentFile = (file) => {
    if(!file) return null
    const lowerUrl = file.toLowerCase();

    return lowerUrl.endsWith('.doc') ||
        lowerUrl.endsWith('.zip') ||
        lowerUrl.endsWith('.xlsx') ||
        lowerUrl.endsWith('.docx') ||
        lowerUrl.endsWith('.xls') ||
        lowerUrl.endsWith('.rar') ||
        lowerUrl.endsWith('csv')
}

/**
 * Lista di icone di react-icon (library FontAwesome 5 direi)
 * @type {{pdf: (props: IconBaseProps) => JSX.Element, doc: (props: IconBaseProps) => JSX.Element, docx: (props: IconBaseProps) => JSX.Element, xls: (props: IconBaseProps) => JSX.Element, xlsx: (props: IconBaseProps) => JSX.Element, csv: (props: IconBaseProps) => JSX.Element, zip: (props: IconBaseProps) => JSX.Element, rar: (props: IconBaseProps) => JSX.Element}}
 */
const extensionIconMap = {
    pdf: FaFilePdf,
    doc: FaFileWord,
    docx: FaFileWord,
    xls: FaFileExcel,
    xlsx: FaFileExcel,
    csv: FaFileCsv,
    zip: FaFileArchive,
    rar: FaFileArchive,
    url: FaExternalLinkAlt,
};

/**
 * Restituisce l' icona per il file passato
 * @param file
 * @returns {*|((props: IconBaseProps) => JSX.Element)}
 */
export const getDocumentFileIcon = (file = '') => {
    const extension = file.split('.').pop()?.toLowerCase();

    return extensionIconMap[extension] || FaFileAlt;
}

/**
 * Restituisce l'icona per i link esterni
 * @returns {(props: IconBaseProps) => JSX.Element}
 */
export const getExternalLinkIcon = () => FaExternalLinkAlt;
/**
 * Restituisce l' estensione del file passato
 * @param file
 * @returns {string|null}
 */
export const getFileExtension = (file) => {
    if(!file) return null
    const extension = file.split('.').pop()?.toLowerCase();

    if(!extension) return null

    return extension
}

/**
 * Determina se il valore passato è un URL
 * @param {string} value
 * @returns {boolean}
 */
export const isUrlAsset = (value) => {
    if (!value || typeof value !== 'string') return false
    return value.startsWith('http://') || value.startsWith('https://')
}
/**
 * Controlla se le properties di un oggetto strutturato con properties => object{children:[], property: string, value:mix}
 * sono tutte empty o senza valori
 * @param {Object} obj
 * @return {boolean}
 */
const isEmptyObject = (obj) => {
    if(!obj) return true

    let result = true

    for (const prop in obj) {
        if(prop?.children?.length > 0 || obj[prop].value !== null) result = false
    }

    return result
}


